const PreLoader = () => {
  return (
    <div className="bg-loader fixed-top position-fixed">
      <div className="loaderImg">
        <div className="lds-ripple">
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default PreLoader;
